"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WEIGHTS = exports.SKINS = exports.SIZES = void 0;
var SIZES = {
  tiny: 'tiny',
  small: 'small',
  medium: 'medium'
};
exports.SIZES = SIZES;
var SKINS = {
  standard: 'standard',
  error: 'error',
  success: 'success',
  premium: 'premium',
  disabled: 'disabled',
  primary: 'primary'
};
exports.SKINS = SKINS;
var WEIGHTS = {
  thin: 'thin',
  normal: 'normal',
  bold: 'bold'
};
exports.WEIGHTS = WEIGHTS;